import { WORKER_URL } from '../config.js';
import { getSession } from '../utils/auth_utils.js';

const authHeaders = async () => {
  const session = await getSession();
  if (!session?.access_token) {
    throw new Error('Authentication required');
  }
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${session.access_token}`
  };
};

const parseRpcResult = async (response, fallbackError) => {
  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }
  if (!response.ok) {
    throw new Error(payload?.error || fallbackError);
  }
  if (payload && payload.success === false) {
    const error = new Error(payload.error || fallbackError);
    error.code = payload.error_code || null;
    throw error;
  }
  return payload || { success: true };
};

export const fetchBlockedContent = async () => {
  const headers = await authHeaders();
  const response = await fetch(`${WORKER_URL}/moderation/blocked`, { method: 'GET', headers });
  const result = await parseRpcResult(response, 'Failed to fetch blocked content');
  const asIdList = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };
  return {
    characters: asIdList(result.characters),
    scenarios: asIdList(result.scenarios)
  };
};

export const reportContent = async ({ contentKind, contentId, reasonCode, reasonText = null }) => {
  const headers = await authHeaders();
  const response = await fetch(`${WORKER_URL}/moderation/report`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      content_kind: contentKind,
      content_id: Number(contentId),
      reason_code: reasonCode,
      reason_text: reasonText
    })
  });
  return parseRpcResult(response, 'Failed to report content');
};

export const blockContent = async ({ contentKind, contentId }) => {
  const headers = await authHeaders();
  const response = await fetch(`${WORKER_URL}/moderation/block`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      content_kind: contentKind,
      content_id: Number(contentId)
    })
  });
  return parseRpcResult(response, 'Failed to block content');
};

export const unblockContent = async ({ contentKind, contentId }) => {
  const headers = await authHeaders();
  const response = await fetch(`${WORKER_URL}/moderation/unblock`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      content_kind: contentKind,
      content_id: Number(contentId)
    })
  });
  return parseRpcResult(response, 'Failed to unblock content');
};
